export const usersErrorMsg = {
  username: 'error_username',
  email: 'error_email',
  id_tag: 'error_id_tag',
  organization_name: 'error_organization_name',
  contact_email: 'error_contact_email',
  contact_phone: 'error_contact_phone',
  password: 'error_password',
  confirm_password: 'error_confirm_password',
};
export const chargingPointsErrorMsg = {
  cp_id: 'error_cp_id',
  kwhAuth: 'error_kwhAuth',
};
